import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/ServicesPage.module.css';
import videoBackground from '../styles/background.mp4';
import ClientNotification from "../shared/ClientNotification";


const ServicesPage = () => {
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");


  const handleShowNotification = (path) => {
    setRedirectPath(path);
    setShowNotification(true);
  };

  const handleNotificationConfirm = () => {
    setShowNotification(false);
    navigate(redirectPath);
  };

  return (
    <div className={styles.sevicesPageContainer}>
      <video className={styles.sevicesPageVideoBackground} autoPlay loop muted>
        <source src={videoBackground} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

        {/* 🔥 Notificare care apare la apăsarea "View Pricing Plans" */}
        {showNotification && <ClientNotification onConfirm={handleNotificationConfirm} />}


      <header className={styles.sevicesPageHeaderMenu}>
        <div onClick={() => navigate('/')} className={styles.sevicesPageLogo}>
          Full Trucking Service
        </div>
        <nav>
          <ul>
            <li onClick={() => navigate('/about')}>About Us</li>
            <li onClick={() => navigate('/services')}>Services</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={() => navigate('/pricing')}>Register</li>
          </ul>
        </nav>
      </header>

      <div className={styles.sevicesPageMainContent}>
        <div className={styles.sevicesPagetextSection}>
          <h1>Our Services - Full Trucking Service</h1>
          <p>
            Full Trucking Service is the leading all-in-one trucking management platform for North and South America. 
            Designed for dispatchers and accountants, our system helps trucking companies streamline their operations, 
            increase efficiency, and maximize profitability.
          </p>

          <h2>All-in-One Dispatch & Accounting Software</h2>
          <p>
            Our platform is specifically built for trucking companies, providing everything you need to run your business in one place. 
            From load management to payroll processing, fuel reporting, and compliance tracking, we offer a complete solution 
            that takes the hassle out of managing a trucking business.
          </p>

          <h2>🚛 Features of Our Platform:</h2>
          <ul>
            <li><strong>Load Management:</strong> Add, track, and assign loads efficiently.</li>
            <li><strong>Payroll Processing:</strong> Automate driver payments based on deliveries and mileage.</li>
            <li><strong>Fuel Reporting:</strong> Generate detailed IFTA and fuel tax reports effortlessly.</li>
            <li><strong>Fleet & Driver Monitoring:</strong> Track your drivers and vehicles in real-time with an advanced dashboard.</li>
            <li><strong>Expense & Profit Analysis:</strong> Get financial insights and reports on revenue, expenses, and profit margins.</li>
            <li><strong>Cloud-Based & Secure:</strong> Access your data from anywhere, with bank-level security.</li>
            <li><strong>Automated Billing & Invoicing:</strong> Generate invoices for loads and send them directly to clients.</li>
            <li><strong>Document Storage:</strong> Store and access important documents, permits, and compliance files in one place.</li>
            <li><strong>Customizable Reports:</strong> Generate and export reports for accounting, compliance, and performance analysis.</li>
            <li><strong>Real-Time Notifications:</strong> Get alerts for load assignments, fuel consumption, and payroll processing.</li>
          </ul>

          <h2>Why Choose Full Trucking Service? 🚀</h2>
          <p>
            With years of experience in the trucking industry, our team understands the challenges of running a successful trucking business. 
            That's why we've designed a platform that not only simplifies dispatching and accounting but also helps trucking companies 
            increase their efficiency and profitability.
          </p>

          <h2>🔍 Monitor Everything Through an Intuitive Dashboard</h2>
          <p>
            Our dashboard gives you complete visibility into your operations. Whether you're managing a single truck 
            or an entire fleet, you can track performance, monitor fuel consumption, and stay on top of compliance regulations 
            with real-time data insights.
          </p>

          <h2>📈 Data-Driven Decisions</h2>
          <p>
            Our advanced analytics provide valuable insights to help you make informed business decisions. 
            Identify high-performing routes, optimize driver schedules, and reduce unnecessary costs with our intelligent reporting tools.
          </p>

          <h2>🌎 Serving Trucking Companies Across North & South America</h2>
          <p>
            Whether you're a small trucking company or a large fleet operator, Full Trucking Service is designed to meet your needs. 
            We provide cutting-edge technology, industry expertise, and seamless integrations to help trucking companies of all sizes 
            succeed in an increasingly competitive market.
          </p>

          <h2>💼 Ready to Optimize Your Trucking Business?</h2>
          <p>
            Join thousands of trucking companies who trust Full Trucking Service to manage their operations efficiently. 
            Discover how our platform can save you time, reduce costs, and improve your bottom line.
          </p>

          <button className={styles.sevicesPagepricingButton} onClick={() => handleShowNotification("/pricing")}>
            View Pricing Plans
          </button>
        </div>
      </div>

 <footer className={styles.sevicesPageFooter}>
 <p onClick={() => navigate('/terms')} className={styles.sevicesPagefooterLink}>
   Terms of Service
 </p>
 <p onClick={() => navigate('/privacy')} className={styles.sevicesPagefooterLink}>
   Privacy Policy
 </p>
 <p onClick={() => navigate('/help')} className={styles.sevicesPagefooterLink}>
   Help
 </p>
</footer>
    </div>
  );
};

export default ServicesPage;
